<div class="rounded-bar-chart" [id]="chartdiv_id"></div>
